import React, { forwardRef, HTMLAttributes } from 'react';

import { PopperDropdown, PopperDropdownAnchor, Text } from '@components/common';
import { Column, Grid } from '@components/common/Grid';
import * as Models from '@components/SurveyBuilder/types/models';
import { Tooltip } from '@components/Tooltip';

interface Props extends HTMLAttributes<HTMLDivElement> {
  surveyId?: number;
  activeBlock?: Models.Block;
}

export const SurveyBuilderHeader = forwardRef<HTMLDivElement, Props>(({ activeBlock, surveyId, ...rest }, ref) => {
  const currentBlockPreviewDisabled = !activeBlock || activeBlock.kind === 'permissions' || !activeBlock.token;

  return (
    <header ref={ref} {...rest}>
      <Grid desktop={12}>
        <Column desktop={2}></Column>
        <Column desktop={8} className='text-center'>
          <Text as='h2' className='mb-2 text-2xl' bold>
            Let's set up your unmoderated usability test
          </Text>
          <Text className='text-sm text-gray-500'>You can always edit this later if things change.</Text>
        </Column>
        <Column desktop={2} className='text-right'>
          <PopperDropdown text='Preview' icon='eye'>
            <PopperDropdownAnchor target='_blank' href={`/studies/${surveyId}/preview/survey`}>
              Preview from start of test
            </PopperDropdownAnchor>
            <Tooltip
              renderRelativeTo='parent'
              isDisabled={!currentBlockPreviewDisabled}
              content='Cannot preview this block.'
            >
              <PopperDropdownAnchor
                target='_blank'
                disabled={currentBlockPreviewDisabled}
                href={`/studies/${surveyId}/preview/survey#${activeBlock?.token}`}
              >
                Preview from current block
              </PopperDropdownAnchor>
            </Tooltip>
          </PopperDropdown>
        </Column>
      </Grid>
    </header>
  );
});
